import React, {useState, useEffect} from 'react'
import {ServiceWorkerContext} from '../context.js'
import * as serviceWorker from '../serviceWorker.js'

const ServiceWorkerProvider = ({children}) => {
  const [hasUpdate, setHasUpdate] = useState(false)

  useEffect(() => {
    serviceWorker.unregister()
    setHasUpdate(false)
    // serviceWorker.register({
    //   onUpdate: () => setHasUpdate(true),
    // })
  }, [])

  const state = {
    hasUpdate,
  }

  return (
    <ServiceWorkerContext.Provider value={state}>
      {children}
    </ServiceWorkerContext.Provider>
  )
}

export default ServiceWorkerProvider
